export const LOGIN_USERNAME_FIELD = 'username';
export const LOGIN_PASSWORD_FIELD = 'password';
export const AUTOFILL_SUBMIT_DELAYS_MS = [0, 50, 150, 300];
export const AUTOFILL_WAIT_MS =
  AUTOFILL_SUBMIT_DELAYS_MS[AUTOFILL_SUBMIT_DELAYS_MS.length - 1] + 50;

export type LoginFormCredentials = {
  username: string;
  password: string;
};

export const getLoginFormCredentials = (
  formElement: HTMLFormElement
): LoginFormCredentials => {
  const usernameInput = formElement.querySelector<HTMLInputElement>(
    `input[name="${LOGIN_USERNAME_FIELD}"]`
  );
  const passwordInput = formElement.querySelector<HTMLInputElement>(
    `input[name="${LOGIN_PASSWORD_FIELD}"]`
  );

  return {
    username: (usernameInput?.value ?? '').trim(),
    password: passwordInput?.value ?? ''
  };
};

export const hasLoginCredentials = (
  credentials: LoginFormCredentials
): boolean => {
  return Boolean(credentials.username && credentials.password);
};

export const scheduleAfterDelays = (
  delays: number[],
  callback: () => void
): number[] => {
  return delays.map(delay => window.setTimeout(callback, delay));
};
